(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5874],{

/***/ 56476:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides",
      function () {
        return __webpack_require__(11585);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ guides; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/search/shared/src/index.ts + 104 modules
var shared_src = __webpack_require__(82870);
// EXTERNAL MODULE: ../../../libs/landing/ui/articles/src/index.ts + 2 modules
var articles_src = __webpack_require__(313);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 264 modules
var ui_shared_src = __webpack_require__(60620);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 57 modules
var ui_src = __webpack_require__(72284);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../../libs/landing/feature-guides-hub/src/lib/components/article-preview-card/article-preview-card.module.css
var article_preview_card_module = __webpack_require__(23239);
var article_preview_card_module_default = /*#__PURE__*/__webpack_require__.n(article_preview_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-guides-hub/src/lib/components/article-preview-card/article-preview-card.tsx








const ArticlePreviewCard = ({ image , date , title , path , featured  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Guides - click article card`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "link",
                    label: title,
                    action: analytics_src/* EventNames.click */.Vy.click
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: classnames_default()((article_preview_card_module_default()).container, {
            [(article_preview_card_module_default()).featuredContainer]: featured
        }),
        "data-testid": "article-preview-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: path,
            passHref: true,
            legacyBehavior: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: "/guides",
                "aria-label": title,
                className: (article_preview_card_module_default()).listItem,
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((article_preview_card_module_default()).imageContainer, {
                            [(article_preview_card_module_default()).featuredImageContainer]: featured
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: (article_preview_card_module_default()).image,
                            alt: (image === null || image === void 0 ? void 0 : image.alt) || "",
                            src: (image === null || image === void 0 ? void 0 : image.filename) || `${ true ? "" : 0}/image-coming-soon.svg`,
                            layout: "responsive",
                            width: featured ? 345 : 110,
                            height: featured ? 220 : 70,
                            priority: featured
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((article_preview_card_module_default()).content, {
                            [(article_preview_card_module_default()).featuredContent]: featured
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                element: "h3",
                                className: (article_preview_card_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                dateTime: date,
                                className: (article_preview_card_module_default()).date,
                                children: (0,util_src/* getDayMonthYearFormat */.Al)(date)
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-guides-hub/src/lib/components/articles-preview/articles-preview.module.css
var articles_preview_module = __webpack_require__(68245);
var articles_preview_module_default = /*#__PURE__*/__webpack_require__.n(articles_preview_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-guides-hub/src/lib/components/articles-preview/articles-preview.tsx








const ArticlesPreview = ({ slug , articles  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)((state)=>({
            trackEvent: state.trackEvent
        }));
    const handleGuideLinkClick = ()=>{
        trackEvent({
            eventName: (0,util_src/* undashifyAndCapitalise */.EQ)(slug),
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "link",
                    label: "guides",
                    action: analytics_src/* EventNames.click */.Vy.click
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (articles_preview_module_default()).container,
        "data-testid": `feature-article-${slug}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                element: "h2",
                className: (articles_preview_module_default()).title,
                children: (0,util_src/* undashifyAndCapitalise */.EQ)(slug)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (articles_preview_module_default()).articlesList,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePreviewCard, {
                        title: articles[0].content.title,
                        path: (0,articles_src/* formatFullSlugToPath */.T)(articles[0].full_slug),
                        image: articles[0].content.image,
                        date: articles[0].first_published_at ?? "",
                        featured: true
                    }, articles[0].content._uid),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                articles.slice(1).map((article)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePreviewCard, {
                                        title: article.content.title,
                                        path: (0,articles_src/* formatFullSlugToPath */.T)(article.full_slug),
                                        image: article.content.image,
                                        date: article.first_published_at ?? ""
                                    }, article.content._uid)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (articles_preview_module_default()).listLink,
                                    "data-testid": `article-sub-hub-link-${slug}`,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: `/guides/${slug}`,
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: (articles_preview_module_default()).link,
                                            href: "/guides",
                                            onClick: handleGuideLinkClick,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (articles_preview_module_default()).linkTitle,
                                                    children: [
                                                        "All ",
                                                        slug.replace(/-/g, " "),
                                                        " articles"
                                                    ]
                                                }),
                                                "→"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-guides-hub/src/lib/components/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-guides-hub/src/lib/guides-hub.module.css
var guides_hub_module = __webpack_require__(83293);
var guides_hub_module_default = /*#__PURE__*/__webpack_require__.n(guides_hub_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-guides-hub/src/lib/guides-hub.tsx










const GuidesHubFeature = ({ content , recentArticleStories  })=>{
    const { vehicleCount  } = (0,shared_src/* useVehicleCount */.qU)();
    const router = (0,next_router.useRouter)();
    const numberOfCars = new Intl.NumberFormat("en-GB").format(vehicleCount ?? 0);
    const renderArticlesPreview = ()=>Object.entries(recentArticleStories).map(([key, articles])=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesPreview, {
                slug: key,
                articles: articles
            }, key));
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Guides-  click search all cars button`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "guides page",
                    label: "button in page",
                    action: "view all cars"
                }
            }
        });
        router.push("/used-cars");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (guides_hub_module_default()).page,
        "data-testid": `feature-article-${content.title}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
                isSlim: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(articles_src/* ArticleHeader */.K, {
                        title: content.title,
                        subTitle: content.subtitle
                    }),
                    renderArticlesPreview()
                ]
            }),
            content.seoSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                isSlim: true,
                className: {
                    inner: (guides_hub_module_default()).seoSection
                },
                children: (0,ui_shared_src/* renderWithResolver */.be)(content.seoSection)
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FullWidthCTA */.S3, {
                iconName: "search",
                iconGradient: "galaxy",
                iconSize: 41,
                title: "Let’s find your next car",
                subtitle: "Ready to hit the open road?",
                buttonLabel: `Search all ${numberOfCars} cars`,
                onButtonClick: handleClick,
                className: (guides_hub_module_default()).fullWidthCta
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-guides-hub/src/index.ts


;// CONCATENATED MODULE: ./pages/guides/index.tsx




function GuidesHub({ guidesHubStory , recentArticleStories , preview  }) {
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story: guidesHubStory,
        enableBridge: preview
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_shared_src/* Head */.Fb, {
                fallbackTitle: "Cars Without The Faff - cinch",
                fallbackDescription: "Welcome to cinch, the faff free way to buy & sell cars. We have thousands of used cars, ready to be sold to you."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuidesHubFeature, {
                content: content,
                recentArticleStories: recentArticleStories
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ var guides = (GuidesHub);


/***/ }),

/***/ 313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* reexport */ ArticleHeader; },
  "T": function() { return /* reexport */ formatFullSlugToPath; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 57 modules
var ui_src = __webpack_require__(72284);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../node_modules/@mui/material/Skeleton/Skeleton.js + 12 modules
var Skeleton = __webpack_require__(78840);
// EXTERNAL MODULE: ../../../libs/landing/ui/articles/src/lib/components/header/header.module.css
var header_module = __webpack_require__(5300);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/articles/src/lib/components/header/header.tsx







const ArticleHeader = ({ title , subTitle , image , video  })=>{
    const { isFallback  } = (0,router.useRouter)();
    const prefersReducedMotion = (0,ui_src/* usePrefersReducedMotion */.Tb)();
    if (isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: (header_module_default()).header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    sx: {
                        marginBottom: "16px"
                    },
                    animation: prefersReducedMotion ? false : "wave",
                    variant: "rectangular",
                    width: 250,
                    height: 61
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    sx: {
                        marginBottom: "16px"
                    },
                    animation: prefersReducedMotion ? false : "wave",
                    variant: "rectangular",
                    width: 750,
                    height: 56
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (header_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (header_module_default()).title,
                "data-testid": "article-title",
                children: title
            }),
            subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (header_module_default()).subTitle,
                children: subTitle
            }),
            ((video === null || video === void 0 ? void 0 : video.length) ?? 0) <= 0 && (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* BaseCard */.bj, {
                className: (header_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,src/* getStoryblokImageServiceUrl */.Vb)(image.filename, {
                        height: 639,
                        width: 960,
                        filters: [
                            {
                                quality: 80
                            }
                        ],
                        fitIn: {
                            width: 960,
                            height: 639
                        }
                    }),
                    alt: image.alt || "article hero"
                })
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/articles/src/lib/utils/format-full-slug-to-path/format-full-slug-to-path.ts
/**
 * This takes the `full_slug` string available in Storyblok story object
 * and formats it so it can be used as a pathname.
 * @param fullSlug i.e. 'articles/guides/choosing-a-car/[slug]'
 * @returns An internal pathname string i.e '/guides/choosing-a-car/[slug]'
 */ const formatFullSlugToPath = (fullSlug)=>`/${fullSlug.slice(fullSlug.indexOf("/") + 1)}`;

;// CONCATENATED MODULE: ../../../libs/landing/ui/articles/src/index.ts




/***/ }),

/***/ 23239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"article-preview-card_container__7obOo","imageContainer":"article-preview-card_imageContainer__pKM_J","content":"article-preview-card_content__3wJeH","title":"article-preview-card_title__HeEHr","featuredContainer":"article-preview-card_featuredContainer___GVei","featuredContent":"article-preview-card_featuredContent__o3p9B","featuredImageContainer":"article-preview-card_featuredImageContainer__gwRqX","date":"article-preview-card_date__nW4CD","image":"article-preview-card_image__pz0_1","listItem":"article-preview-card_listItem__1Pz82"};

/***/ }),

/***/ 68245:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"articles-preview_container__dCq0N","title":"articles-preview_title__vx76N","link":"articles-preview_link__0ZP9H","linkTitle":"articles-preview_linkTitle___PM8k","articlesList":"articles-preview_articlesList__R_U86","listLink":"articles-preview_listLink__ZjcU2"};

/***/ }),

/***/ 83293:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"guides-hub_page__ezKO5","seoSection":"guides-hub_seoSection__bh9rq","fullWidthCta":"guides-hub_fullWidthCta__MLO5x"};

/***/ }),

/***/ 5300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__bf1yM","title":"header_title__4GtYq","subTitle":"header_subTitle__1gtFs","video":"header_video__Fu0gh","imageWrapper":"header_imageWrapper__48_mj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2878,2870,9774,2888,179], function() { return __webpack_exec__(56476); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);